<template lang="pug">
v-overlay(v-model="open")
	div.tw-flex.tw-flex-col.tw-items-center.tw-justify-center.tw-gap-2
		img(src="/layout/preloader_forexchange_trenitalia.gif")
		div.tw-font-bold(v-if="title") {{ title }}
</template>

<script setup>
import { ref } from 'vue';

const open = ref(true);
defineProps({
	title: String
})
</script>

<style scoped>
.v-overlay{
	align-items: center;
	justify-content: center;
}
.v-overlay img{
	height: 150px;
}
.v-overlay :deep(.v-overlay__scrim){
	opacity: 1;
	background: #efefef;
}
</style>